import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 06E68A9B-2ED4-4697-82A2-02F1FA342D55
 * name exclamation
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/exclamation.svg
 * tags
 * - Math 
 */
export const ExclamationIcon = createSvgIcon(<><path d="M 11,4L 13,4L 13,15L 11,15L 11,4 Z M 13,18L 13,20L 11,20L 11,18L 13,18 Z" /></>, 'ExclamationIcon');
export default ExclamationIcon